import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/JwtService";
import { number } from "yup";
/**
 * @description service to call HTTP request via Axios
 */
class cadService {
    /**
     * @description initialize vue axios
     */
    static init(app) {
        cadService.vueInstance = app;
        if (!cadService.vueInstance.axios)
            cadService.vueInstance.use(VueAxios, axios);
        cadService.BaseUrl = import.meta.env.VITE_CAD_URL;
    }
    /**
     * @description set the default HTTP request headers
    */
    static setHeader() {
        cadService.vueInstance.axios.defaults.headers.common["Authorization"] = "Bearer " + JwtService.getToken();
        cadService.vueInstance.axios.defaults.headers.common["Accept"] =
            "application/json";
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static query(resource, params) {
        return cadService.vueInstance.axios.get(`${cadService.BaseUrl}/${resource}`, params);
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param slug: string
     * @returns Promise<AxiosResponse>
     */
    static get(resource, slug = "") {
        return cadService.vueInstance.axios.get(`${cadService.BaseUrl}/${resource}/${slug}`);
    }
    /**
     * @description set the POST HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static post(resource, params) {
        return cadService.vueInstance.axios.post(`${cadService.BaseUrl}/${resource}`, params);
    }
    /**
    * @description Send the PUT HTTP request
    * @param resource: string
    * @param params: AxiosRequestConfig
    * @returns Promise<AxiosResponse>
    */
    static put(resource, params) {
        return cadService.vueInstance.axios.put(`${cadService.BaseUrl}/${resource}`, params);
    }
    /**
    * @description Send the DELETE HTTP request
    * @param resource: string
    * @param slug: number
    * @returns Promise<AxiosResponse>
    */
    static delete(resource, slug = number) {
        return cadService.vueInstance.axios.delete(`${cadService.BaseUrl}/${resource}/${slug}`);
    }
}
export default cadService;
//********** COMENTÁRIO GERADO EM: 18/08/2022 03:08:52 **********
//
//import { App } from "vue";
//import axios from "axios";
//import VueAxios from "vue-axios";
//import JwtService from "@/core/services/JwtService";
//import { AxiosResponse, AxiosRequestConfig } from "axios";
//import { number } from "yup";
//
///**
// * @description service to call HTTP request via Axios
// */
//class cadService {
//    /**
//     * @description property to share vue instance
//     */
//    public static vueInstance: App;
//    private static BaseUrl;
//
//    /**
//     * @description initialize vue axios
//     */
//    public static init(app: App<Element>){
//        cadService.vueInstance = app;
//        cadService.vueInstance.use(VueAxios, axios);
//        //cadService.vueInstance.axios.defaults.baseURL = import.meta.env.VITE_cad_URL;
//        cadService.BaseUrl = import.meta.env.VITE_CAD_URL;
//    }
//
//    /**
//     * @description set the default HTTP request headers
//    */
//    public static setHeader() : void {
//        cadService.vueInstance.axios.defaults.headers.common[
//            "Authorization"
//        ] = "Bearer " + JwtService.getToken();
//		cadService.vueInstance.axios.defaults.headers.common["Accept"] =
//            "application/json";
//    }
//
//    /**
//     * @description send the GET HTTP request
//     * @param resource: string
//     * @param params: AxiosRequestConfig
//     * @returns Promise<AxiosResponse>
//     */
//    public static query(
//		resource: string,
//		params: AxiosRequestConfig
//
//    ) : Promise<AxiosResponse> {
//        return cadService.vueInstance.axios.get(`${cadService.BaseUrl}/${resource}`, params);
//    }
//
//    /**
//     * @description send the GET HTTP request
//     * @param resource: string
//     * @param slug: string
//     * @returns Promise<AxiosResponse>
//     */
//    public static get(
//        resource: string,
//        slug = "" as string
//    ): Promise<AxiosResponse> {
//        return cadService.vueInstance.axios.get(`${cadService.BaseUrl}/${resource}/${slug}`);
//    }
//
//    /**
//     * @description set the POST HTTP request
//     * @param resource: string
//     * @param params: AxiosRequestConfig
//     * @returns Promise<AxiosResponse>
//     */
//    public static post(
//        resource: string,
//        params: AxiosRequestConfig
//    ): Promise<AxiosResponse> {
//        return cadService.vueInstance.axios.post(`${cadService.BaseUrl}/${resource}`, params);
//    }
//
//    /**
//    * @description Send the PUT HTTP request
//    * @param resource: string
//    * @param params: AxiosRequestConfig
//    * @returns Promise<AxiosResponse>
//    */
//    public static put(
//        resource: string,
//        params: AxiosRequestConfig
//    ): Promise<AxiosResponse> {
//        return cadService.vueInstance.axios.put(`${cadService.BaseUrl}/${resource}`, params);
//    }
//
//    /**
//    * @description Send the DELETE HTTP request
//    * @param resource: string
//    * @param slug: number
//    * @returns Promise<AxiosResponse>
//    */
//    public static delete(
//        resource: string,
//        slug = number
//    ): Promise<AxiosResponse> {
//        return cadService.vueInstance.axios.delete(`${cadService.BaseUrl}/${resource}/${slug}`);
//    }
//
//
//}
//
//export default cadService;
//
//
//********** FIM DO COMENTÁRIO **********
//# sourceMappingURL=cadService.js.map